import { createStore } from 'redux'

const initialState = {
  shippingCost: 0.00,
  selectedQuote: {},
  quotes: [],
  shippingDiscount:0,
  totals: {},
  backorder: false
}

const recalculate_taxes = (totals) => {
  if(totals.taxable == true ){
    let out = (parseInt(totals.taxable_items_total, 10) + parseInt(totals.shipping, 10));
    return Math.round(out * 0.07);
  }
  else{
    return 0.0;
  }
}


const recalculate_total = (totals) =>{
  let tax = recalculate_taxes(totals);
  let total = totals.sub_total;
  total += totals.shipping;
  total += tax;
  total -= totals.promo_amount;
  total -= totals.account_credit; 

  // if (total < 0){
  //   let diff = Math.abs(total
  // }

  return set(totals, {total: total, tax: tax });
}

const select_shipping = (state, action) => {
  let totals = state.totals;
  let shipping_price = Math.max(action.quote.price - state.shippingDiscount, 0.0)
  let new_totals = set(totals, {shipping: shipping_price , shipping_name: action.quote.service });

  return set(state, {selectedQuote: action.quote, totals:  recalculate_total(new_totals)});
}

const set = (state,new_props) => {
  return Object.assign({}, state, new_props);
}

const shipping = (state = initialState, action) => {
  switch(action.type){
    case "NEW_SHIPPING_QUOTES":
      return set(state, action.initialState);
    case "SELECT_SHIPPING":
      return select_shipping(state, action);
    case "LOAD_TOTALS":
      return set(state, action.initialState );
    default:
      return state;
  }
}

export default shipping;

